exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".feedback-section{width:770px;height:auto;display:block}.input-email,.input-text,.input-url{margin-bottom:20px}.input-multiline{margin-bottom:37px}.form-naming{margin-left:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2120bc4f","scoped":false,"hasInlineConfig":true}!./src/components/form-feedback/form-feedback.css
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-2120bc4f","scoped":false,"hasInlineConfig":true}!./src/components/form-feedback/form-feedback.css
// module chunks = index